module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20214.a2beba0f.jpg";